<template>
  <div class="event-type">
    <Card style="padding-bottom: 40px">
      <Button @click="addEventType" type="primary">添加</Button>
      <Table
          :loading="eventTypeLoading"
          :columns="columns"
          :data="data"
          :border="true"
          :highlight-current-row="true"
          style="margin-top: 10px"
      >
        <template #action="{ row, index }">
          <el-button size="small" type="text" @click="getEventTypeById(row)">编辑</el-button>
          <el-button size="small" type="text" @click="deleteEventType(row)">删除</el-button>
        </template>
      </Table>
    </Card>
    <Modal v-model="eventTypeModal"
           :title="isEdit ? '修改' : '添加'"
    >
      <Form :model="eventTypeFrom" :rules="eventTypeRules" :label-width="100" ref="eventTypeFrom">
        <FormItem label="事件类型" prop="name">
          <Input v-model="eventTypeFrom.name"></Input>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button @click="eventTypeModal = false">取消</Button>
        <Button v-if="!isEdit" type="primary" :loading="addLoading" @click="addType">确定</Button>
        <Button v-else type="primary" :loading="addLoading" @click="editType">修改</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "eventType",
  data() {
    return {
      eventTypeModal: false,
      eventTypeLoading: false,
      addLoading: false,
      isEdit: false,
      columns: [
        {
          title: 'id',
          key: 'id',
          align: 'center',
        },
        {
          title: '事件类型',
          key: 'name',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      eventTypeFrom: {
        name: '',
      },
      eventTypeRules: {
        name: [
          { required: true, message: '请输入事件类型', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.getEventType()
  },
  methods: {
    addType() {
      this.$refs.eventTypeFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          this.$http.post('/api/eventTypes', this.eventTypeFrom).then(res => {
            this.addLoading = false
            this.eventTypeModal = false
            this.$Message.success('添加成功')
            this.getEventType()
          })
        } else {
          return false
        }
      })
    },
    getEventTypeById(row) {
      let id = row.id
      this.$http.get(`/api/eventTypes/${ id }`).then(res => {
        if (res.status === 200) {
          this.isEdit = true
          this.eventTypeFrom = res.data
          this.eventTypeModal = true
        } else {
          this.$Message.error('获取数据失败')
        }
      })
    },
    editType() {
      this.$refs.eventTypeFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let request = {
            ...this.eventTypeFrom
          }
          this.$http.put(`/api/eventTypes`, request).then(res => {
            if (res.status === 200) {
              this.addLoading = false
              this.eventTypeModal = false
              this.$Message.success('修改成功')
              this.getEventType()
            } else {
              this.$Message.error('修改失败')
            }
          })
        } else {
          return false
        }
      })
    },
    addEventType() {
      this.eventTypeModal = true
      this.isEdit = false
      this.eventTypeFrom = {}
    },
    getEventType() {
      this.$http.get('/api/eventTypes').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
        }
      })
    },
    deleteEventType(row){
      this.$http.delete(`/api/eventTypes/${row.id}`).then(res => {
        console.log(res)
        this.getEventType()
      })
    }
  }
}
</script>

<style scoped>

</style>
